import { render, staticRenderFns } from "./SchoolAddress.vue?vue&type=template&id=745feefc&"
import script from "./SchoolAddress.vue?vue&type=script&lang=ts&"
export * from "./SchoolAddress.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolAddress.vue?vue&type=style&index=0&id=745feefc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports